import React from 'react';
import { FiPlay, FiHeart, FiMessageCircle } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      {/* SEO hidden content for crawlers */}
      <h2 className="seo-hidden">Best Dating & Hookup App in India - Available in Delhi, Mumbai, Kolkata, Bangalore, Chennai, Hyderabad, Pune, Ahmedabad</h2>
      <p className="seo-hidden">Slink is the #1 video dating and hookup app for singles in India. Find dates, meet new people, and earn money through video calls. Available in Delhi NCR, Mumbai, Kolkata, Bangalore, Chennai, Hyderabad, Pune, Ahmedabad, Jaipur, Lucknow, Chandigarh, Gurgaon, Noida, Indore, Bhopal, Patna, Ranchi, Guwahati, Nagpur, Surat, Coimbatore, Vizag, Kochi, and all major Indian cities. Free download on Android.</p>
      <div className="hero-bg-effects">
        <div className="hero-glow glow-1"></div>
        <div className="hero-glow glow-2"></div>
        <div className="hero-glow glow-3"></div>
      </div>
      <div className="container hero-content">
        <div className="hero-text">
          <div className="hero-badge">
            <FiPlay size={14} />
            <span>Video Dating App</span>
          </div>
          <h1>
            Connect. Chat.<br />
            <span className="gradient-text">Earn Money.</span>
          </h1>
          <p className="hero-subtitle">
            Meet real people through video calls, build genuine connections, 
            and earn money while you chat. India's most exciting dating & social platform.
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">10K+</span>
              <span className="stat-label">Active Users</span>
            </div>
            <div className="stat">
              <span className="stat-number">₹15/min</span>
              <span className="stat-label">Earn Per Call</span>
            </div>
            <div className="stat">
              <span className="stat-number">4.8★</span>
              <span className="stat-label">User Rating</span>
            </div>
          </div>
          <div className="hero-actions" id="download">
            <a href="https://slink.astergo.in/slink-dating-app.apk" className="btn-download">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z"/>
              </svg>
              <div>
                <small>Download on</small>
                <strong>Google Play</strong>
              </div>
            </a>
            <div className="btn-ios-soon">
              <span>iOS Coming Soon</span>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <div className="phone-mockup">
            <div className="phone-screen">
              <div className="mock-header">
                <div className="mock-avatar accent"></div>
                <div className="mock-text-lines">
                  <div className="mock-line w60"></div>
                  <div className="mock-line w40 light"></div>
                </div>
              </div>
              <div className="mock-cards">
                <div className="mock-card">
                  <div className="mock-card-img"></div>
                  <div className="mock-card-info">
                    <div className="mock-line w80"></div>
                    <div className="mock-line w50 light"></div>
                  </div>
                  <div className="mock-card-badge online"></div>
                </div>
                <div className="mock-card">
                  <div className="mock-card-img alt"></div>
                  <div className="mock-card-info">
                    <div className="mock-line w70"></div>
                    <div className="mock-line w40 light"></div>
                  </div>
                  <div className="mock-card-badge"></div>
                </div>
              </div>
              <div className="mock-bottom-bar">
                <FiHeart className="mock-icon" />
                <FiMessageCircle className="mock-icon active" />
                <FiPlay className="mock-icon" />
              </div>
            </div>
          </div>
          <div className="floating-badge badge-1">
            <FiHeart size={16} color="var(--accent)" />
            <span>New Match!</span>
          </div>
          <div className="floating-badge badge-2">
            <span>💰</span>
            <span>₹250 earned</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
